import React, { Component } from "react";

import GuarenteeIcon from "../../assets/guarentee__icon.png";

import Button from "@atlaskit/button";
import EmptyState from "@atlaskit/empty-state";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    console.log(error);
    console.log(info);
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <EmptyState
          header="Oops. Something has gone wrong"
          description={`We've alerted the techs about this error. In the meantime, please try again in a moment.`}
          imageUrl={GuarenteeIcon}
          primaryAction={
            <a href={"/"}>
              <Button>Home</Button>
            </a>
          }
        />
      );
    }
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/errorBoundary/ErrorBoundary.js